// File: /opt/dev_environment/assets/workspace/app-init/src/pages/VokabelnPage/DeleteConfirmDialog.js

import React, { useEffect, useCallback } from 'react';
import './VokabelnPage.css';

function DeleteConfirmDialog({ card, onConfirm, onCancel }) {
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  const handleOverlayClick = useCallback((e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  }, [onCancel]);

  return (
    <div
      className="vokabeln-dialog-overlay"
      onClick={handleOverlayClick}
      role="alertdialog"
      aria-modal="true"
      aria-label="Vokabel löschen"
    >
      <div className="vokabeln-dialog">
        <div className="vokabeln-dialog__header">
          <h2 className="vokabeln-dialog__title">Vokabel löschen</h2>
          <button
            className="vokabeln-dialog__close"
            type="button"
            onClick={onCancel}
            aria-label="Dialog schließen"
          >
            ✕
          </button>
        </div>

        <div className="vokabeln-dialog__body">
          <div className="vokabeln-confirm__icon" role="img" aria-hidden="true">
            ⚠️
          </div>
          <p className="vokabeln-confirm__message">
            Möchtest du dieses Wort wirklich löschen?
          </p>
          <p className="vokabeln-confirm__message">
            <span className="vokabeln-confirm__word">
              {card.germanWord} — {card.italianWord}
            </span>
          </p>

          <div className="vokabeln-dialog__actions">
            <button
              className="vokabeln-dialog__btn vokabeln-dialog__btn--cancel"
              type="button"
              onClick={onCancel}
            >
              Abbrechen
            </button>
            <button
              className="vokabeln-dialog__btn vokabeln-dialog__btn--delete"
              type="button"
              onClick={onConfirm}
            >
              Löschen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmDialog;